import React, { useEffect, useMemo, useState } from "react";
import DatePickercomp from "../../components/DatePicker";
import { Col, Table, Form, Row, Spinner, Stack } from "react-bootstrap";
import { PunchItemRemarksCell, usePunchRequestRemarks } from "../../components/ItemRemarks";
import Select from "react-select";
import { ErrorMessage, FieldArray, Formik } from "formik";
import ReactTextareaAutosize from "react-textarea-autosize";
import { getAllComplaintIdList, getAllEndUserBySupervisorId, getAllItemMasterForDropdown, getAllItemMasterForDropdownUsingUserid, getAllItemMasterForStockPunch, getAllManagersUser, getAllOfficeUser, getFundRequestById, getItemPriceDetails, getItemPriceDetailsStockPunch, getPreviousFundRequestById, getSupervisorListWithTotalFreeUserByManagerId, getUserFinancialSummary, postFundPunchApproveByOffice, postTransferExpenseFund, postTransferExpenseStock } from "../../services/contractorApi";
import { toast } from "react-toastify";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { useTranslation } from "react-i18next";
import { MdEdit } from "react-icons/md";
import TooltipComponent from "../../components/TooltipComponent";
import { BsDashLg, BsPlusLg, BsQuestionLg } from "react-icons/bs";
import { CreateBillImages } from "../StockRequest/CreateBillImages";
import ConfirmAlert from "../../components/ConfirmAlert";
import OtpInput from "react-otp-input";
import { ArrowLeft } from "lucide-react";
import FundTableView from "../FundManagement/fund-transfer/FundTableView";
import { RescheduledTransferFundSchema } from "../../utils/formSchema";
import { PaymentImages } from "./PaymentImages";

import { onlyDecimalKey, handleDecimalPaste, formatAmountINR } from "../../utils/helper";
// Exact product — no rounding. Backend should receive the full-precision
// value so qty × price === total holds. Display layers can format as needed.
const calculateItemAmount = (qty, rate) => Number(qty) * Number(rate);

// Show a clean DD-MM-YYYY date from a MySQL datetime / ISO string
// (e.g. "2026-06-01T00:00:00.000Z" → "01-06-2026").
const formatDateOnly = (v) => {
  if (!v) return "";
  const d = String(v).slice(0, 10); // YYYY-MM-DD
  const [y, m, day] = d.split("-");
  return day && m && y ? `${day}-${m}-${y}` : d;
};

// Normalize a date (Date | "YYYY-MM-DD..." | "DD-MM-YYYY") to a comparable
// "YYYY-MM-DD" string. Used by both the submit guard and the as-of-date item
// filter so dates compare consistently.
const toIso = (v) => {
  if (!v) return "";
  if (v instanceof Date) {
    const y = v.getFullYear();
    const m = String(v.getMonth() + 1).padStart(2, "0");
    const d = String(v.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  const s = String(v).slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const mt = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  return mt ? `${mt[3]}-${mt[2]}-${mt[1]}` : s;
};

const ExpenseFundTransfer = () => {
  const { id } = useParams();
  const { user } = useSelector(selectUser);
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [allOfficeUser, setAllofficeUser] = useState([]);
  const [debugTransferData, setDebugTransferData] = useState(null);
  // const [transferById, setTransferById] = useState(user?.id);
  // const [transferById, setTransferById] = useState(type === "stock" ? id : user?.id);
  const [showAlert, setShowAlert] = useState(false);
  const [allManagers, setAllManagers] = useState([]);
  const [supervisoForTransferFrom, setSupervisorForTransferFrom] = useState([]);
  const [supervisoForTransferTo, setSupervisorForTransferTo] = useState([]);
  const [endUserForTransferTo, SetEndUserForTransferTo] = useState([]);
  const [endUserForTransferFrom, SetEndUserForTransferFrom] = useState([]);
  const [accountBalance, setAccountBalance] = useState({ balance: 0 });
  const [allAccountByBankId, setAllAccountByBankId] = useState([]);
  // const [edit, setEdit] = useState({});
  const [edit, setEdit] = useState({
    approved_data: {
      request_fund: [],
      new_request_fund: [],
    },
  });
  const [itemMasterData, setItemMasterData] = useState([]);
  const [previousFundAmountData, setPreviousFundAmountData] = useState([]);
  const [userFinancialSummary, setUserFinancialSummary] = useState(null);
  const [fromUserFinancialSummary, setFromUserFinancialSummary] = useState(null);
  const [previousFundAmount, setPreviousFundAmount] = useState(0);
  const [finalRequestAmount, setFinalRequestAmount] = useState(0);
  const [showRescheduled, setShowRescheduled] = useState(false);
  const [complaintList, setComplaintList] = useState([]);

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || null;
  // each item's earlier remarks (Request / Approve / Transfer of the
  // employee's open requests), in the row's Remarks cell
  const punchRemarks = usePunchRequestRemarks(type === "stock" ? "stock" : "fund", { userId: id });
  const [transferById, setTransferById] = useState(null);
  console.log("type", type);
  console.log("transferById", transferById);
  const fetchUserFundDetails = async (userId) => {
    if (!userId) {
      setPreviousFundAmountData([]);
      return;
    }
    // The chosen receiver is recorded FIRST, whatever the lookup below says.
    // It used to be set only when the previous-request lookup succeeded, so a
    // receiver with no earlier requests (Lokesh Kumar, prod 2026-09-19) was
    // never recorded: the payload kept the previously picked manager /
    // supervisor as transfer_to — "Invalid transfer user." when that was also
    // the sender, and a transfer to the WRONG person when it was not.
    setEdit((prev) => ({ ...prev, request_for_id: userId }));
    const res = await getPreviousFundRequestById(userId);

    if (res.status) {
      setPreviousFundAmountData(res.data);
      setEdit((prev) => ({
        ...prev,
        request_for: res.data?.[0]?.user_name,
        request_for_id: userId,
      }));
    } else {
      setPreviousFundAmountData([]);
    }
  };
  const fetchUserFinancialSummary = async (userId) => {
    if (!userId) {
      setUserFinancialSummary(null);
      return;
    }
    const res = await getUserFinancialSummary(userId);
    if (res.status) {
      const data = Array.isArray(res.data) ? res.data[0] : res.data;
      setUserFinancialSummary(data ?? null);
    } else {
      setUserFinancialSummary(null);
    }
  };

  const fetchFromUserFinancialSummary = async (userId) => {
    if (!userId) {
      setFromUserFinancialSummary(null);
      return;
    }
    const res = await getUserFinancialSummary(userId);
    if (res.status) {
      const data = Array.isArray(res.data) ? res.data[0] : res.data;
      setFromUserFinancialSummary(data ?? null);
    } else {
      setFromUserFinancialSummary(null);
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const isStock = type === "stock";
    const transferPrimaryKey = edit?.id || id || "";

    if (!values.fund_transfer_date) {
      toast.error("Please select the fund transfer date");
      setSubmitting(false);
      return;
    }

    // Transfer date must be on/after the item's transfer date — clean message
    // up-front so the user never hits a verbose backend error.
    {
      const toIso = (v) => {
        if (!v) return "";
        if (v instanceof Date) {
          const y = v.getFullYear();
          const m = String(v.getMonth() + 1).padStart(2, "0");
          const d = String(v.getDate()).padStart(2, "0");
          return `${y}-${m}-${d}`;
        }
        const s = String(v).slice(0, 10);
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
        const mt = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
        return mt ? `${mt[3]}-${mt[2]}-${mt[1]}` : s;
      };
      const transferIso = toIso(values.fund_transfer_date);
      let minItemIso = null;
      (values.transfer_items || []).forEach((it) => {
        if (!(Number(it?.transfer_item_qty) > 0)) return;
        const td = toIso(it.transfer_date);
        if (td && (!minItemIso || td < minItemIso)) minItemIso = td;
      });
      if (minItemIso && transferIso && transferIso < minItemIso) {
        toast.error("Transfer date should be greater than the item's transfer date");
        setSubmitting(false);
        return;
      }
    }

    const transferItems = values.transfer_items
      // Only send month/tranche rows the user actually filled. Each item now
      // expands into one row per month, so unfilled rows (qty 0) must be
      // dropped — otherwise the backend rejects the whole transfer.
      .filter((itm) => itm.item_id && Number(itm.transfer_item_qty) > 0)
      .map((itm) => {
        const price = Number(itm.approved_price) || 0;
        const qty = Number(itm.transfer_item_qty) || 0;
        const fifoAmount = Number(itm.transfer_amount) || calculateItemAmount(qty, price);
        // Exact unit price derived from FIFO total ÷ qty — no rounding so
        // backend gets full precision (price × qty === fifoAmount holds).
        const fifoUnitPrice = qty > 0 ? fifoAmount / qty : price;
        const base = {
          item_name: itm.item_name,
          new_price: isStock ? fifoUnitPrice : price,
          price: isStock ? fifoUnitPrice : price,
          quantity: qty,
          transfer_quantity: qty,
          remaining_quantity: Number(itm.remaining_item_qty) || 0,
          fund_id: itm.fund_id || "",
          // The exact batch this line transfers from (per-row model).
          stock_id: itm.stock_id || "",
        };
        if (isStock) {
          return { ...base, request_transfer_stock: fifoAmount };
        }
        return { ...base, request_transfer_fund: fifoAmount };
      });

    console.log("FROM USER:", id);
    console.log("TO USER:", transferById);
    console.log("TOTAL TRANSFER:", transferItems);
    console.log("FROM BALANCE:", fromUserFinancialSummary?.fund_balance);

    const transferDataKey = isStock ? "transfer_stock" : "transfer_fund";
    const newTransferDataKey = isStock ? "new_transfer_stock" : "new_transfer_fund";
    const dateKey = isStock ? "stock_transfer_date" : "fund_transfer_date";

    const payload = {
      id: edit?.id,
      transfer_from: id,
      // the person picked in the Office / Manager / Supervisor / End User boxes
      transfer_to: transferById || edit?.request_for_id,
      from_key: transferPrimaryKey,
      category_type: "FE",
      remark: values.remark || "",
      payment_mode: values.payment_mode || 2,
      transaction_id: values.transaction_id || "",
      [dateKey]: values.fund_transfer_date || "",
      transfer_data: [
        {
          [transferDataKey]: transferItems,
          [newTransferDataKey]: [],
        },
      ],
      reschedule_fund: values.reschedule_fund || [],
    };
    console.log("TRANSFER PAYLOAD:", payload);
    const res = isStock
      ? await postTransferExpenseStock(payload)
      : await postTransferExpenseFund(payload);

    if (res.status) {
      toast.success(res.message);
      navigate(-1);
    } else {
      toast.error(res.message);
    }

    setSubmitting(false);
  };
  const handleSupervisorChange = async (value, type) => {
    if (!value) return SetEndUserForTransferTo([]);
    fetchFreeUsersData(value, type);
  };
  const fetchFreeUsersData = async (id, type) => {
    const res = await getAllEndUserBySupervisorId(id);
    if (res.status) {
      if (type == "transfer_from") {
        SetEndUserForTransferFrom(res.data);
      } else {
        SetEndUserForTransferTo(res.data);
      }
    } else {
      SetEndUserForTransferFrom([]);
      SetEndUserForTransferTo([]);
      toast.error(res.message);
    }
  };
  const handleManagerChange = async (value) => {
    if (!value) {
      setSupervisorForTransferFrom([]);
      return;
    }

    fetchsupervisoForTransferFrom(value);
  };
  const fetchsupervisoForTransferFrom = async (id) => {
    const res = await getSupervisorListWithTotalFreeUserByManagerId(id);
    console.log("supervisor data", res.data);
    if (res.status) {
      setSupervisorForTransferFrom(res.data);
    } else {
      setSupervisorForTransferFrom([]);
      toast.error(res.message);
    }
  };
  const getAllOptions = (props) => {
    const selectedItem = props.values.transfer_items?.map(
      (e) => e?.item_name?.value
    ) || [];
    return itemMasterData.filter(
      (value) => !selectedItem.includes(value?.product_id || value?.item_id)
    );
  };

  const handleItemSelect = async (selectedOption, props, index) => {
    const setFieldValue = props.setFieldValue;

    let res;
    if (type === "stock") {
      res = await getItemPriceDetailsStockPunch(selectedOption.value, id);
    } else {
      res = await getItemPriceDetails(selectedOption.value, id);
    }

    // Both fund and stock APIs now return ONE entry per batch/month tranche.
    // Expand into one row per tranche; each row is single-rate so
    // amount = qty × rate (no FIFO). Stock rows carry stock_id (+ supplier);
    // fund rows carry fund_id. The user picks how much to transfer from each.
    const allRows = res.status && Array.isArray(res.data) ? res.data : [];
    // AS-OF-DATE: only offer batches that were transferred to this user ON OR
    // BEFORE the selected fund transfer date — a back-dated transfer must not be
    // able to move funds that arrived later. (Date is picked first; the item
    // dropdown is gated until then.) Same toIso comparison the submit guard uses.
    const selIso = toIso(props.values.fund_transfer_date);
    const rows = selIso
      ? allRows.filter((r) => {
          const td = toIso(r?.transfer_date);
          return !td || td <= selIso;
        })
      : allRows;
    if (selIso && allRows.length && !rows.length) {
      toast.error(
        "No funds for this item were transferred on or before the selected date."
      );
    }
    const isStock = type === "stock";
    const makeRow = (r) => ({
      id: "",
      item_name: selectedOption,
      item_id: selectedOption.value,
      fund_id: isStock ? "" : r?.fund_id ?? "",
      stock_id: isStock ? r?.stock_id ?? "" : "",
      transfer_date: formatDateOnly(r?.transfer_date),
      approved_price: Number(r?.item_price) || 0,
      remaining_item_qty: Number(r?.remaining_quantity) || 0,
      remaining_amt: Number(r?.remaining_amount) || 0,
      supplier_name: r?.supplier_name || "",
      transfer_item_qty: "",
      transfer_amount: 0,
    });
    const trancheRows = rows.length ? rows.map(makeRow) : [makeRow(null)];

    const current = [...props.values.transfer_items];
    current.splice(index, 1, ...trancheRows);
    setFieldValue("transfer_items", current);
  };
  const itemFormatOptionLabel = ({ label, image }) => (
    <div className="d-flex">
      <img src={image} className="avatar me-2" />
      <span>{label}</span>
    </div>
  );
  const ResetField = (props) => {
    props.setFieldValue("transfer_items", [
      {
        id: "",
        item_name: "",
        item_id: "",
        approved_price: 0,
        remaining_item_qty: "",
        remaining_amt: "",
        fund_id: "",
        transfer_item_qty: "",
        transfer_amount: 0,
      },
    ]);
  };
  const fetchOfficeUsers = async () => {
    const res = await getAllOfficeUser();
    if (res.status) {
      setAllofficeUser(res.data);
    } else {
      setAllofficeUser([]);
    }
  };

  const fetchManagers = async () => {
    const res = await getAllManagersUser();
    if (res.status) {
      setAllManagers(res.data);
    } else {
      setAllManagers([]);
    }
  };

  const fetchComplaintList = async () => {
    const res = await getAllComplaintIdList();
    if (res.status) {
      setComplaintList(res.data);
    } else {
      setComplaintList([]);
    }
  };

  // useEffect(() => {
  //   fetchOfficeUsers();
  //   fetchManagers();
  //   fetchComplaintList();
  //   fetchItemMasterData(id);
  //   fetchFundRequestDetails();
  //   fetchFromUserFinancialSummary(id);
  // }, [id]);

  // useEffect(() => {
  //   fetchOfficeUsers();
  //   fetchManagers();
  //   fetchComplaintList();

  //   if (type === "stock") {
  //     fetchItemMasterData(id);
  //   } else {
  //     fetchItemMasterData(transferById);
  //   }

  //   // fetchFundRequestDetails();
  //   fetchFromUserFinancialSummary(transferById);
  // }, [id, transferById, type]);

useEffect(() => {
  fetchOfficeUsers();
  fetchManagers();
  fetchComplaintList();
  fetchItemMasterData(id);

  // id (from URL) always populates the "From" card
  fetchFromUserFinancialSummary(id);

  // fund request details only needed for fund type
  if (type !== "stock") {
    fetchFundRequestDetails();
  }

}, [id, type]);

  useEffect(() => {
    if (!debugTransferData) return;
    console.log("ROW AFTER SELECT:", debugTransferData);
  }, [debugTransferData]);



  // const fetchItemMasterData = async (userId) => {
  //   if (!userId) return setItemMasterData([]);
  //   const res = await getAllItemMasterForDropdownUsingUserid(userId);
  //   if (res.status) {
  //     const uniqueItems = [
  //       ...new Map(res?.data?.map((item) => [item.item_id, item])).values(),
  //     ];
  //     setItemMasterData(uniqueItems);
  //   } else {
  //     setItemMasterData([]);
  //   }
  // };


  // ✅ SAFE EDIT HELPER (ADD HERE)

  const fetchItemMasterData = async (userId) => {

    if (!userId) return setItemMasterData([]);

    let res;

    if (type === "stock") {
      res = await getAllItemMasterForStockPunch(userId);
    } else {
      res = await getAllItemMasterForDropdownUsingUserid(userId);
    }

    if (res.status) {
      const uniqueItems = [
        ...new Map(
          res.data.map((item) => [
            item.product_id || item.item_id,
            item
          ])
        ).values(),
      ];
      console.log("itemMasterData", uniqueItems);
      setItemMasterData(uniqueItems);
    } else {
      setItemMasterData([]);
    }
  };

  const getSafeEdit = (edit, main) => {
    return {
      ...edit,
      approved_data: {
        request_fund:
          edit?.approved_data?.request_fund?.length > 0
            ? edit.approved_data.request_fund
            : main?.transfer_fund || [],
        new_request_fund:
          edit?.approved_data?.new_request_fund || [],
      },
    };
  };

  // ✅ REQUEST BASED ITEMS (MAIN MAGIC)
  // ✅ FINAL CORRECT SOURCE

  const requestBasedItems = useMemo(() => {
    const fundList =
      edit?.approved_data?.request_fund ||
      edit?.request_fund?.request_fund ||
      [];

    if (!Array.isArray(fundList)) return [];

    return fundList?.map((itm) => ({
      id: itm?.item_name?.value,
      name: itm?.item_name?.label,
      unique_id: itm?.item_name?.unique_id,
      rate: itm?.rate?.rate || itm?.new_price || 0,
      hsncode: itm?.item_name?.hsncode,
      description: itm?.item_name?.description,
      image: itm?.item_name?.image,
    }));
  }, [edit]);
  console.log("EDIT FINAL:", edit)
  console.log("ITEM SOURCE:", edit?.request_fund?.request_fund);

  const fetchFundRequestDetails = async () => {
    if (!id) return;

    const res = await getFundRequestById(id);

    if (res.status) {
      setEdit(res.data);
    }
    console.log("FUND REQUEST RESPONSE:", res);
  };

  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-3">
        <ArrowLeft
          size={22}
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        {/* <h5 className="mb-0 fw-bold">
          {t("Transfer Fund")}
        </h5> */}
        <h5 className="mb-0 fw-bold">
  {type === "stock" ? t("Transfer Stock") : t("Transfer Fund")}
</h5>
      </div>
      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <Formik

          enableReinitialize={true}
          // enableReinitialize={false}
          initialValues={{
            transfered_by: { label: "", value: user.id },
            transfered_to: "",
            stock_transfer_from: "1",
            remark: "",
            payment_mode: 2,
            transaction_id: "",
            // Left blank on purpose: if the user picks a date, the receiver's
            // batch uses it; if NOT picked, the backend keeps the SOURCE batch's
            // original date (not today). So we don't force today here.
            fund_transfer_date: "",
            // complaint_id: edit?.complaint_id || "",
            reschedule_fund: [
              {
                reschedule_fund: [],
                new_reschedule_fund: []
              }
            ],
            payment_images: [],
            request_stock_images: [
              {
                item_image: "",
                title: "",
                transaction_id: "",
                payment_mode: "",
              },
            ],

            transfer_items: [
              {
                id: "",
                item_name: "",
                item_id: "",
                approved_price: 0,
                remaining_item_qty: "",
                remaining_amt: "",
                fund_id: "",
                supplier_name: "",
                transfer_item_qty: "",
                transfer_amount: 0,
              },
            ],
            request_data: [
              {
                transfer_fund: [
                  {
                    current_user_stock: "",
                    previous_price: "",
                  },
                ],
              },
            ],
            transfer_data:
              requestBasedItems?.length > 0
                ? [
                  {
                    transfer_fund: requestBasedItems?.map(() => ({
                      item_name: null,
                      current_user_stock: "",
                      previous_price: "",
                      current_price: "",
                      request_quantity: "",
                      fund_amount: "",
                      price: 0,
                      quantity: 0,
                      transfer_quantity: 0,
                      request_transfer_fund: 0,
                      remaining_quantity: "",
                    })),
                    new_transfer_fund: [],
                  },
                ]
                : [
                  {
                    transfer_fund: [
                      {
                        item_name: null,
                        current_user_stock: "",
                        previous_price: "",
                        current_price: "",
                        request_quantity: "",
                        fund_amount: "",
                        price: 0,
                        quantity: 0,
                        transfer_quantity: 0,
                        request_transfer_fund: 0,
                        remaining_quantity: "",
                      },
                    ],
                    new_transfer_fund: [],
                  },
                ],
          }}
          // validationSchema={addStockPunchSchema}
          onSubmit={handleSubmit}
        >

          {(props) => {
            //             setTimeout(() => {
            //   setDebugTransferData(props.values.transfer_data);
            // }, 0);
            console.log("REQUEST BASED:", requestBasedItems);
            console.log("TRANSFER DATA:", props?.values?.transfer_data);


            return (
              <Form onSubmit={props?.handleSubmit}>
                <Row className="g-3">
                  <FieldArray name="transfer_items">
                    {({ remove, push }) => (
                      <div className="mb-4">
                        <div className="d-flex">
                          <Form.Group as={Col} md="3">
                            <Form.Label className="small">
                              {t("Office")}
                            </Form.Label>
                            <Select
                              placeholder={t("Office")}
                              menuPortalTarget={document.body}
                              isClearable={true}
                              isDisabled={props.values.manager_in_transfer_from}
                              // isDisabled={false}
                              options={allOfficeUser?.map((user) => ({
                                label: user.name,
                                value: user.id,
                              }))}
                              onChange={(e) => {
                                if (e) {
                                  setTransferById(e?.value);
                                  props.setFieldValue("transfered_by", e);
                                  props.setFieldValue("office_in_transfer_from", e);
                                  setEdit(prev => ({ ...prev, request_for_id: e.value }));
                                  fetchUserFinancialSummary(e.value);
                                } else {
                                  props.setFieldValue("office_in_transfer_from", "");
                                  setUserFinancialSummary(null);
                                }
                                props.setFieldValue("manager_in_transfer_from", "");
                                props.setFieldValue("supervisor_in_transfer_from", "");
                                ResetField(props);
                              }}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="3" className="mx-1">
                            <Form.Label className="small">
                              {t("Manager")}
                            </Form.Label>
                            <Select
                              placeholder={t("Manager")}
                              name="manager_in_transfer_from"
                              value={props.values.manager_in_transfer_from || null}
                              menuPortalTarget={document.body}
                              isClearable={true}
                              options={allManagers?.map((user) => ({
                                label: user.name,
                                value: user.id,
                              }))}
                              isDisabled={
                                props.values.office_in_transfer_from
                              }
                              onChange={(e) => {
                                if (e) {
                                  handleManagerChange(e?.value);
                                  props.setFieldValue("transfered_by", e);
                                  props.setFieldValue("manager_in_transfer_from", e);
                                  props.setFieldValue("supervisor_in_transfer_from", "");
                                  props.setFieldValue("enduser_in_transfer_from", "");
                                  setSupervisorForTransferFrom([]);
                                  SetEndUserForTransferFrom([]);
                                  setTransferById(e?.value);
                                  setEdit(prev => ({ ...prev, request_for_id: e.value }));
                                  fetchUserFinancialSummary(e.value);
                                } else {
                                  setSupervisorForTransferFrom([]);
                                  SetEndUserForTransferFrom([]);
                                  props.setFieldValue("manager_in_transfer_from", "");
                                  props.setFieldValue("supervisor_in_transfer_from", "");
                                  props.setFieldValue("enduser_in_transfer_from", "");
                                  setUserFinancialSummary(null);
                                }
                                ResetField(props);
                              }}
                            />
                            <ErrorMessage
                              name="area_manager_id"
                              component="small"
                              className="text-danger"
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="3">
                            <Form.Label className="small">
                              {t("Supervisor")}
                            </Form.Label>
                            <Select
                              placeholder={t("Supervisor")}
                              value={props.values.supervisor_in_transfer_from || null}
                              menuPortalTarget={document.body}
                              // value={main?.supervisor_id}
                              isClearable={true}
                              isDisabled={!!props.values.office_in_transfer_from}
                              options={supervisoForTransferFrom?.map(
                                (user) => ({
                                  label: user.name,
                                  value: user.id,
                                })
                              )}
                              onChange={(e) => {
                                if (e?.value) {
                                  handleSupervisorChange(e?.value, "transfer_from");
                                  props.setFieldValue("supervisor_in_transfer_from", e);
                                  props.setFieldValue("enduser_in_transfer_from", "");
                                  SetEndUserForTransferFrom([]);
                                  // the supervisor is the receiver until an end user is picked
                                  setTransferById(e?.value);
                                  fetchUserFundDetails(e.value);
                                  fetchUserFinancialSummary(e.value);
                                } else {
                                  props.setFieldValue("supervisor_in_transfer_from", "");
                                  props.setFieldValue("enduser_in_transfer_from", "");
                                  SetEndUserForTransferFrom([]);
                                  setPreviousFundAmountData([]);
                                  setUserFinancialSummary(null);
                                  setEdit({ approved_data: { request_fund: [], new_request_fund: [] } });
                                }
                              }}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="3">
                            <Form.Label className="small">
                              {t("End User")}
                            </Form.Label>
                            <Select
                              placeholder={t("End User")}
                              value={props.values.enduser_in_transfer_from || null}
                              menuPortalTarget={document.body}
                              isClearable={true}
                              isDisabled={!!props.values.office_in_transfer_from}
                              options={endUserForTransferFrom?.map(
                                (user) => ({
                                  label: user.name,
                                  value: user.id,
                                })
                              )}
                              onChange={(e) => {
                                if (e) {
                                  setTransferById(e?.value);
                                  props.setFieldValue("enduser_in_transfer_from", e);
                                  props.setFieldValue("transfered_by", e);
                                  fetchUserFundDetails(e.value);
                                  fetchUserFinancialSummary(e.value);
                                } else {
                                  setTransferById(props.values.supervisor_in_transfer_from?.value);
                                  props.setFieldValue("enduser_in_transfer_from", "");
                                  props.setFieldValue("transfered_by", props.values.supervisor_in_transfer_from);
                                  setPreviousFundAmountData([]);
                                  setUserFinancialSummary(null);
                                  setEdit({ approved_data: { request_fund: [], new_request_fund: [] } });
                                }
                                ResetField(props);
                              }}
                            />
                          </Form.Group>
                        </div>
                        <div className="d-flex">
                          {/* <Form.Group as={Col} md={3} className="mb-3">
                            <Form.Label className="small">{t("Complaint ID")}</Form.Label>
                            <Select
                              placeholder={t("Select Complaint")}
                              menuPortalTarget={document.body}
                              isClearable
                              options={complaintList?.map((itm) => ({
                                label: itm.complaint_unique_id,
                                value: itm.id,
                              }))}
                              value={
                                complaintList
                                  ?.map((itm) => ({ label: itm.complaint_unique_id, value: itm.id }))
                                  .find((opt) => opt.value === props.values.complaint_id) || null
                              }
                              onChange={(e) => {
                                props.setFieldValue("complaint_id", e ? e.value : "");
                              }}
                            />
                            <ErrorMessage
                              name="complaint_id"
                              component="small"
                              className="text-danger"
                            />
                          </Form.Group> */}
                          <Form.Group className="mb-3 mx-1" as={Col} md={3}>
                            <Form.Label> {type === "stock" ? t("Stock Transfer Date") : t("Fund Transfer Date")}</Form.Label>
                            <DatePickercomp
                              name="fund_transfer_date"
                              value={props.values.fund_transfer_date}
                              sendDate={(value) => {
                                props.setFieldValue("fund_transfer_date", value);
                              }}
                              onBlur={props.handleBlur}
                              label={t("Select Fund Date")}
                              isInvalid={Boolean(
                                props.touched.fund_transfer_date &&
                                props.errors.fund_transfer_date
                              )}
                              // Block dates before the LOWEST (earliest) transfer date of
                              // the SELECTED items — kicks in as soon as an item is picked
                              // (qty not required). transfer_date is DD-MM-YYYY. Skip the
                              // limit if none / unparseable / future (never lock the picker).
                              minDate={(() => {
                                const items = props?.values?.transfer_items || [];
                                let minTd = null;
                                items.forEach((it) => {
                                  if (!it?.transfer_date) return;
                                  const parts = String(it.transfer_date).split("-");
                                  if (parts.length !== 3) return;
                                  const [dd, mm, yyyy] = parts.map(Number);
                                  const d = new Date(yyyy, mm - 1, dd);
                                  if (isNaN(d.getTime())) return;
                                  if (!minTd || d < minTd) minTd = d;
                                });
                                if (!minTd) return null;
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                return minTd > today ? null : minTd;
                              })()}
                            />
                            <ErrorMessage
                              name="fund_transfer_date"
                              component="small"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <Row className="mt-3">
                          <Col md={6}>
                            <div className="p-20 shadow rounded h-100">
                              <strong className="text-secondary">
                                {t("From")}
                              </strong>

                              <div className="mt-2">
                                <table className="table-sm table">
                                  <tbody>
                                    <tr>
                                      <th>{t("User Name")} :</th>
                                      <td>{fromUserFinancialSummary?.user_name || "-"}</td>
                                    </tr>
                                    <tr>
                                      <th>{t("Bank Name")} :</th>
                                      <td>{fromUserFinancialSummary?.bank_name || "-"}</td>
                                    </tr>
                                    <tr>
                                      <th>{t("Account No")} :</th>
                                      <td>{fromUserFinancialSummary?.account_number || "-"}</td>
                                    </tr>
                                    <tr>
                                      <th>{t("IFSC Code")} :</th>
                                      <td>{fromUserFinancialSummary?.ifsc_code || "-"}</td>
                                    </tr>
                                    <tr>
                                      <th>{t("Account Balance")} :</th>
                                      <td>{formatAmountINR(fromUserFinancialSummary?.account_balance ?? 0)}</td>
                                    </tr>
                                    <tr>
                                      <th>{t("Stock Balance")} :</th>
                                      <td>{formatAmountINR(fromUserFinancialSummary?.stock_balance ?? 0)}</td>
                                    </tr>
                                    <tr>
                                      <th>{t("Fund Balance")} :</th>
                                      <td>{formatAmountINR(fromUserFinancialSummary?.fund_balance ?? 0)}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="p-20 shadow rounded h-100">
                              <strong className="text-secondary">
                                {t("To")}
                              </strong>

                              <div className="mt-2">
                                <table className="table-sm table">
                                  <tbody>
                                    <tr>
                                      <th>{t("User Name")} :</th>
                                      <td>{userFinancialSummary?.user_name || "-"}</td>
                                    </tr>

                                    <tr>
                                      <th>{t("Fund Limit")} :</th>
                                      <td>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <span>
                                            {formatAmountINR(userFinancialSummary?.fund_limit ?? 0)}
                                          </span>

                                          <MdEdit
                                            className="ms-3 text-primary"
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "18px",
                                            }}
                                            title="Edit Fund Limit"
                                            onClick={() =>
                                              navigate(
                                                `/Employees/AddEmployee/${edit?.request_for_id}`
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>

                                    <tr>
                                      <th>{t("Total Transfer Amount")} :</th>
                                      <td>
                                        {formatAmountINR(userFinancialSummary?.transfer_amount || 0)}
                                      </td>
                                    </tr>

                                    <tr>
                                      <th>{t("Total Punched Amount")} :</th>
                                      <td>
                                        {formatAmountINR(userFinancialSummary?.total_punched_amount || 0)}
                                      </td>
                                    </tr>

                                    <tr>
                                      <th>{t("Remaining Limit")} :</th>
                                      <td>
                                        {formatAmountINR(userFinancialSummary?.remaining_fund_limit || 0)}
                                      </td>
                                    </tr>

                                    <tr>
                                      <th>{t("Requested Amount")} :</th>
                                      <td>
                                        {formatAmountINR(userFinancialSummary?.old_request_amount || 0)}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="g-3 mt-2">
                          {props.values.transfer_items.length > 0 && (
                            <Table striped hover className="text-body bg-new Roles">
                              <thead>
                                <tr>
                                  <th>{t("Item Name")}</th>
                                  <th>{t("Transfer Date")}</th>
                                  <th>{t("Remaining Qty")}</th>
                                  <th>{t("Remaining Amount")}</th>
                                  <th>{t("Transfer Qty")}</th>
                                  <th>{t("Total Amount")}</th>
                                  {type === "stock" && (
                                    <th>{t("Supplier Name")}</th>
                                  )}
                                  <th>{t("Action")}</th>
                                  <th style={{ minWidth: "220px" }}>{t("Remarks")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {props.values.transfer_items.map((itm, index) => (
                                  <tr key={index}>
                                    {/* Item Name dropdown — options from itemMasterData */}
                                    <td width="220px">
                                      <Select
                                        className="text-start"
                                        menuPortalTarget={document.body}
                                        // Date-first: item can't be picked until a
                                        // fund transfer date is chosen, so the rows
                                        // can be scoped to that as-of date.
                                        isDisabled={!props.values.fund_transfer_date}
                                        placeholder={
                                          props.values.fund_transfer_date
                                            ? t("Select Item")
                                            : type === "stock"
                                            ? t("Select stock transfer date first")
                                            : t("Select fund transfer date first")
                                        }
                                        value={props.values.transfer_items[index]?.item_name || null}
                                        options={getAllOptions(props).map((opt) => ({
                                          label: opt.item_name || opt.new_item,
                                          value: opt.product_id || opt.item_id,
                                          image: opt.item_image
                                            ? `${process.env.REACT_APP_API_URL}${opt.item_image}`
                                            : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`,
                                        }))}
                                        onChange={(e) =>
                                          handleItemSelect(e, props, index)
                                        }
                                        formatOptionLabel={itemFormatOptionLabel}
                                      />
                                      <ErrorMessage
                                        name={`transfer_items.${index}.item_name`}
                                        component="span"
                                        className="text-danger"
                                      />
                                    </td>

                                    {/* Transfer Date — the month/tranche this row belongs to */}
                                    <td>
                                      <Form.Control
                                        placeholder="-"
                                        disabled
                                        value={itm?.transfer_date || ""}
                                      />
                                    </td>

                                    {/* Remaining Qty — from getItemPriceDetails */}
                                    <td>
                                      <Form.Control
                                        placeholder="0"
                                        disabled
                                        value={itm?.remaining_item_qty ?? ""}
                                      />
                                    </td>

                                    {/* Remaining Amount — from getItemPriceDetails */}
                                    <td>
                                      <Form.Control
                                        placeholder="0"
                                        disabled
                                        value={itm?.remaining_amt ?? ""}
                                      />
                                    </td>

                                    {/* Transfer Qty — user input, capped at remaining_item_qty */}
                                    <td>
                                      <Form.Control
                                        type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                        step="0.01"
                                        placeholder="0"
                                        min={0}
                                        disabled={!itm.remaining_item_qty}
                                        name={`transfer_items.${index}.transfer_item_qty`}
                                        value={itm?.transfer_item_qty}
                                        onChange={(e) => {
                                          // const max = Number(itm.remaining_item_qty || 0);
                                          // const qty = Math.min(Number(e.target.value), max);
                                          const max = Number(itm.remaining_item_qty || 0);
                                          const price = Number(itm?.approved_price || 0);

                                          const rawValue = e.target.value;

                                          // allow up to 3 decimal places
                                          if (!/^\d*\.?\d{0,3}$/.test(rawValue)) return;

                                          let qty = Number(rawValue);

                                          const exceedsMax = qty > max;
                                          if (exceedsMax) qty = max;

                                          // Preserve user's raw string so an in-progress decimal
                                          // ("1.") survives re-render and the user can finish
                                          // typing "1.5". Only overwrite with the capped number
                                          // when they exceed the max.
                                          props.setFieldValue(
                                            `transfer_items.${index}.transfer_item_qty`,
                                            exceedsMax ? qty : rawValue
                                          );

                                          // Single rate per row (this month's tranche) → simple
                                          // qty × rate. No FIFO; the user already picked the month.
                                          props.setFieldValue(
                                            `transfer_items.${index}.transfer_amount`,
                                            +(qty * price).toFixed(2)
                                          );
                                        }}
                                      />
                                      <ErrorMessage
                                        name={`transfer_items.${index}.transfer_item_qty`}
                                        component="span"
                                        className="text-danger"
                                      />
                                    </td>

                                    {/* Total Amount — auto-calculated */}
                                    <td>
                                      <Form.Control
                                        type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                        step="0.01"
                                        placeholder="0"
                                        min={0}
                                        disabled={!itm.remaining_item_qty}
                                        value={itm?.transfer_amount ?? ""}
                                        onChange={(e) => {

                                          const price = Number(itm?.approved_price || 0);
                                          const remainingQty = Number(itm?.remaining_item_qty || 0);

                                          const rawValue = e.target.value;

                                          if (!/^\d*\.?\d{0,2}$/.test(rawValue)) return;

                                          let amount = Number(rawValue);

                                          // Single rate per row → cap at this month's remaining
                                          // amount and derive qty = amount / rate.
                                          const maxAmount =
                                            Number(itm?.remaining_amt) || remainingQty * price;

                                          const exceedsMax = amount > maxAmount;
                                          if (exceedsMax) {
                                            amount = maxAmount;
                                          }

                                          const qty = price ? +(amount / price).toFixed(3) : 0;

                                          // Preserve raw string so trailing dot ("1.")
                                          // survives mid-type — Number conversion would
                                          // collapse "1." to 1, blocking decimal entry.
                                          props.setFieldValue(
                                            `transfer_items.${index}.transfer_amount`,
                                            exceedsMax ? amount : rawValue
                                          );

                                          props.setFieldValue(
                                            `transfer_items.${index}.transfer_item_qty`,
                                            qty
                                          );
                                        }}
                                      />
                                    </td>
                                    {/* <td>
                                      <Form.Control
                                        placeholder="0"
                                        disabled
                                        value={itm?.transfer_amount ?? ""}
                                      />
                                    </td> */}

                                    {type === "stock" && (
                                      <td>{itm?.supplier_name ?? "--"}</td>
                                    )}

                                    {/* Add / Remove */}
                                    <td className="text-center">
                                      {index === 0 ? (
                                        <TooltipComponent title={t("Add")}>
                                          <BsPlusLg
                                            className="social-btn success-combo"
                                            onClick={() =>
                                              props.setFieldValue("transfer_items", [
                                                ...props.values.transfer_items,
                                                {
                                                  id: "",
                                                  item_name: "",
                                                  item_id: "",
                                                  approved_price: "",
                                                  remaining_item_qty: "",
                                                  remaining_amt: "",
                                                  fund_id: "",
                                                  transfer_item_qty: "",
                                                  transfer_amount: "",
                                                },
                                              ])
                                            }
                                          />
                                        </TooltipComponent>
                                      ) : (
                                        <TooltipComponent title={t("Remove")}>
                                          <BsDashLg
                                            className="social-btn red-combo"
                                            onClick={() =>
                                              props.setFieldValue(
                                                "transfer_items",
                                                props.values.transfer_items.filter(
                                                  (_, idx) => idx !== index
                                                )
                                              )
                                            }
                                          />
                                        </TooltipComponent>
                                      )}
                                    </td>
                                    <td>
                                      <PunchItemRemarksCell remarks={punchRemarks} itemName={itm?.item_name?.label} canEdit />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}

                          {/* Auto-calculated grand total of every row's
                              "Total Amount" (transfer_amount). Computed straight
                              from props.values on each render, so it updates live
                              as the user changes any TRANSFER QTY / amount.
                              Empty/NaN rows are treated as 0. */}
                          {props.values.transfer_items.length > 0 && (
                            <div className="d-flex justify-content-end mt-2">
                              <strong>
                                {t("Total Transfer Amount")} :{" "}
                                {formatAmountINR(
                                  props.values.transfer_items.reduce(
                                    (total, itm) =>
                                      total +
                                      (Number(itm?.transfer_amount) || 0),
                                    0
                                  )
                                )}
                              </strong>
                            </div>
                          )}
                        </Row>

                        <Row className="mt-3">

                          <Form.Group as={Col} md={6} className="mb-3">
                            <Form.Label>{t("Remarks")}</Form.Label>
                            <ReactTextareaAutosize
                              minRows={0}
                              placeholder="type remarks..."
                              onChange={props.handleChange}
                              value={props.values.remark}
                              name={"remark"}
                              className="edit-textarea"
                              onBlur={props.handleBlur}
                              isInvalid={Boolean(
                                props.touched.remark && props.errors.remark
                              )}
                            />
                            <ErrorMessage
                              name="remark"
                              component="small"
                              className="text-danger"
                            />
                          </Form.Group>

                          <Form.Group
                            controlId="transaction_id"
                            as={Col}
                            md={6}
                            className="mb-3"
                          >
                            <Form.Label>
                              {props.values.payment_mode === "CHEQUE"
                                ? "Cheque No."
                                : props.values.payment_mode === "CASH"
                                  ? "Voucher No."
                                  : t("Transactions Id")}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={
                                props.values.payment_mode === "CHEQUE"
                                  ? "Enter Cheque No."
                                  : props.values.payment_mode === "CASH"
                                    ? "Enter Voucher No."
                                    : t(" Enter Transaction Id")
                              }
                              name={`transaction_id`}
                              onChange={props.handleChange}
                              onBlur={props.handleBlur}
                              isInvalid={Boolean(
                                props.touched.transaction_id &&
                                props.errors.transaction_id
                              )}
                            />
                            <ErrorMessage
                              name="transaction_id"
                              component="small"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Row>
                        <Form.Group as={Col} md={12}>
                          <div className="mt-2 text-center">
                            <button
                              type={`button`}
                              onClick={() => {
                                props.handleSubmit();
                                setOtp("");
                              }}
                              disabled={props?.isSubmitting}
                              className="shadow border-0 purple-combo cursor-pointer px-4 py-1"
                            >
                              {props?.isSubmitting ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                  />
                                  {t("PLEASE WAIT")}...
                                </>
                              ) : (
                                <>{t("Transfer")}</>
                              )}
                            </button>

                            <ConfirmAlert
                              size={"sm"}
                              defaultIcon={<BsQuestionLg />}
                              deleteFunction={props.handleSubmit}
                              hide={setShowAlert}
                              show={showAlert}
                              title={"Verify Otp"}
                              description={"Please Enter the Otp !!"}
                              children={
                                <Row>
                                  <Col md={1}></Col>
                                  <Col md={8} className="position-relative mx-5">
                                    <OtpInput
                                      className="fs-5 mx-1"
                                      value={otp}
                                      isInputNum={true}
                                      onChange={setOtp}
                                      numInputs={6}
                                      renderInput={(props) => <input {...props} />}
                                    />
                                  </Col>
                                </Row>
                              }
                            />
                          </div>
                        </Form.Group>

                      </div>
                    )}
                  </FieldArray>
                </Row>
              </Form>
            )
          }}
        </Formik>
      </Col>
    </>
  )
}
export default ExpenseFundTransfer
